<template>
  <div
    v-if="favoritePlaceList.isFavorite(place)"
    class="col-6 remove-favorites-block"
    @click="favoritePlaceList.remove(place)"
  >
    <span v-t="'place_card.remove_from_favorites.label'" class="remove-favorites-label" />
    <i class="remove-favorites-icon bi bi-heart" />
  </div>
  <div
    v-else
    class="col-6 add-favorites-block"
    @click="favoritePlaceList.add(place)"
  >
    <span v-t="'place_card.add_to_favorites.label'" class="add-favorites-label" />
    <i class="add-favorites-icon bi bi-heart" />
  </div>
</template>

<script>
import { useFavoritePlaceList } from '@/store/FavoritePlaceList'

export default {
  name: 'PlaceFavoriteIconBlock',
  props: {
    place: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const favoritePlaceList = useFavoritePlaceList()

    return { favoritePlaceList }
  },
}

</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins/breakpoints';

.remove-favorites-block,
.add-favorites-block {
  display: flex;
  justify-content: end;
  align-items: center;
  cursor: pointer;

  .remove-favorites-label,
  .add-favorites-label {
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.063rem;
    text-align: center;
    color: var(--main-theme-color);
    margin-right: 0.313rem;
  }

  .remove-favorites-icon,
  .add-favorites-icon {
    color: var(--main-theme-color);
    font-size: 0.938rem;
  }
}

.remove-favorites-block {
  .bi-heart::before {
    content: '\f415';
  }
}

@include media-breakpoint-down(lg) {
  .add-favorites-block:hover, .add-favorites-block:focus {
    .add-favorites-label {
      text-decoration: underline;
    }

    .bi-heart::before {
      content: '\f415';
    }
  }
}

.remove-favorites-block:hover, .remove-favorites-block:focus {
  .remove-favorites-label {
    text-decoration: underline;
  }

  .bi-heart::before {
    content: '\f417';
  }
}
</style>
